import { Moment } from 'moment';

export enum CalendarViewType {
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
  QUARTERLY = 'quarterly',
}

export interface getUTCDateProps {
  startDate?: string | Moment;
  endDate?: string | Moment;
}

export interface DateFormatPreference {
  dateFormat: DateFormatEnum;
}

export interface TimeFormatPreference {
  timeFormat: TimeFormatEnum;
}

export enum TimeFormatEnum {
  SHORT_TIME_FORMAT = `HH:mm`,
  SHORT_12_HOUR_TIME_FORMAT = `hh:mm A`,
  SHORT_12_HOUR_TIME_FORMAT_LOWER_CASE = `hh:mm a`,
  SHORTEST_12_HOUR_TIME_FORMAT = `h:mm A`,
  SHORTEST_24_HOUR_TIME_FORMAT_LOWER_CASE = `H:mm a`,
  DETAILED_24_HOUR_TIME_FORMAT = `HH:mm:ss`,
  DETAILED_12_HOUR_TIME_FORMAT = `hh:mm:ss A`,
  DETAILED_12_HOUR_TIME_FORMAT_LOWER_CASE = `hh:mm:ss a`,
  TIME_24_HOUR_FORMAT = `H:mm:ss`,
  TIME_12_HOUR_FORMAT = `h:mm:ss A`,
  TIME_12_HOUR_FORMAT_LOWER_CASE = `h:mm:ss a`,
  TIME_FORMAT_EVENT = `HH:mm:ssZ`,
  COMPLETE_TIME_FORMAT_24_HOURS = 'HH:mm:ssTZD',
  COMPLETE_TIME_FORMAT_12_HOURS = 'hh:mm:ssTZD',
  DETAILED_24_HOUR_TIME_FORMAT_FRACTION = `HH:mm:ss.SSS`,
  DETAILED_12_HOUR_TIME_FORMAT_FRACTION = `hh:mm:ss.SSS A`,
  DETAILED_12_HOUR_TIME_FORMAT_LOWER_CASE_FRACTION = `hh:mm:ss.SSS a`,
  TIME_24_HOUR_FORMAT_FRACTION = `H:mm:ss.SSS`,
  TIME_12_HOUR_FORMAT_FRACTION = `h:mm:ss.SSS A`,
  TIME_12_HOUR_FORMAT_LOWER_CASE_FRACTION = `h:mm:ss.SSS a`,
  TIME_FORMAT_EVENT_FRACTION = `HH:mm:ss.SSSZ`,
  COMPLETE_TIME_FORMAT_FRACTION_24_HOURS = 'HH:mm:ss.SSSTZD',
  COMPLETE_TIME_FORMAT_FRACTION_12_HOURS = 'hh:mm:ss.SSSTZD',
  NO_TIME_FORMAT = '',
}

export enum DateFormatEnum {
  DATE_FORMAT_YEAR = `YYYY`,
  SHORT_DATE_FORMAT_LINE = `YYYY-MM`,
  SHORT_DATE_FORMAT_LINE_REVERSED = `MM-YYYY`,
  SHORT_DATE_FORMAT = `YYYY/MM`,
  SHORT_DATE_FORMAT_REVERSED = `MM/YYYY`,
  DATE_FORMAT = `MM/DD/YYYY`,
  DATE_FORMAT_REVERSED = `DD/MM/YYYY`,
  DATE_FORMAT_ISO = `YYYY/MM/DD`,
  DATE_FORMAT_ISO_REVERSED = `YYYY/DD/MM`,
  DATE_FORMAT_LINE = `MM-DD-YYYY`,
  DATE_FORMAT_LINE_REVERSED = `DD-MM-YYYY`,
  DATE_FORMAT_LINE_YEAR_FIRST = `YYYY-MM-DD`,
  DATE_FORMAT_NO_LINE = `MM DD YYYY`,
  DATE_FORMAT_NO_LINE_REVERSED = `DD MM YYYY`,
  SHORT_DATE_DAY_TEXT_FORMAT = `MM Do YYYY`,
  SHORT_DATE_DAY_TEXT_FORMAT_REVERSED = `Do MM YYYY`,
  SHORT_DATE_MONTH_TEXT_FORMAT = 'MMM DD, YYYY',
  SHORT_DATE_MONTH_TEXT_FORMAT_REVERSED = 'DD MMM, YYYY',
  LONG_DATE_MONTH_TEXT_FORMAT = 'MMM Do, YYYY',
  LONG_DATE_MONTH_TEXT_FORMAT_REVERSED = 'Do MMM, YYYY',
  SHORT_DATE_WEEKDAY_TEXT_FORMAT = 'ddd, MMM DD YYYY',
  LONG_DATE_WEEKDAY_TEXT_FORMAT = 'dddd, MMMM DD YYYY',
  SHORT_DATE_WEEKDAY_DAY_TEXT_FORMAT = 'ddd, MMM Do YYYY',
  LONG_DATE_WEEKDAY_DAY_TEXT_FORMAT = 'dddd, MMMM Do YYYY',
}

export type DateRange = {
  start: Moment;
  end: Moment;
};

export type CalendarViewRangeType =
  | 'yesterday'
  | 'lastWeek'
  | 'thisWeek'
  | 'lastMonth'
  | 'thisMonth'
  | 'currentYear'
  | 'daily'
  | 'monthly'
  | 'weekly'
  | 'yearly'
  | 'lastWeekSameDayDate'
  | 'currentWeekInMonth'
  | 'currentMonth'
  | 'today'
  | 'quarterly'
  | 'default';

export type CalendarPreviousNextTypeRange =
  | 'past5Weeks'
  | 'next5weeks'
  | 'past12months'
  | 'next12months'
  | 'previousWeek'
  | 'nextWeek'
  | 'past7Week'
  | 'next7week'
  | 'past7months'
  | 'next7months'
  | 'past7years'
  | 'next7years'
  | 'last7Days'
  | 'next7Days'
  | 'previousMonth'
  | 'nextMonth'
  | 'previousDay'
  | 'nextDay'
  | 'weeklyDateRange'
  | 'monthlyDateRange'
  | 'yearlyDateRange'
  | 'dailyDateRange'
  | 'quarterlyDateRange'
  | 'pastYear'
  | 'nextYear'
  | 'past5Years'
  | 'next5Years'
  | 'past7WeekDayDate'
  | 'past7monthDayDate';
